import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { effectiveBackgroundColor } from 'utils/exportImage';
import { Button, Flex } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFileImage } from '@fortawesome/pro-light-svg-icons';
import * as ExcelJS from 'exceljs';
import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';

const generateImage = () => {
    const node = document.querySelector('.Stakes .ant-layout-content') as HTMLElement;
    if (!node) return;
    domtoimage.toBlob(node, {
        bgcolor: effectiveBackgroundColor(node),
        quality: 1,
        filter: (n: any) => {
            if (!n.className || !n.className.match) return true;
            return !n.className.match('ActionsWrapper') && !n.className.match('ant-btn');
        }
    }).then((blob) => {
        saveAs(blob, `Gerositus-Stakes-${new Date().toLocaleDateString().replace(/\//g, '-')}.png`);
    });
};

const generateExcel = async (stakes: any[]) => {
    const sorted = sortBy(stakes, ['reference', 'name']);

    const workbook = new ExcelJS.Workbook();
    workbook.created = new Date();

    const sheet = workbook.addWorksheet('Stakes');
    sheet.columns = [
        { header: 'Name', key: 'name', width: 50 },
        { header: 'Reference', key: 'reference', width: 16 },
        { header: 'Description', key: 'description', width: 80 },
        { header: 'Weight', key: 'weight', width: 12 },
        { header: 'Trend', key: 'trend', width: 12 },
    ];

    sheet.addRows(sorted.map((s) => [s.name, s.reference, s.description, s.weight, s.trend]));
    sheet.autoFilter = { from: 'A1', to: 'E1' };

    sheet.getRow(1).eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDDDDDD' } };
        cell.font = { bold: true, size: 16 };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Gerositus-Stakes.xlsx');
};

export const ExportTab = ({ stakes }: { stakes: any[] }) => {
    const { t } = useTranslation();

    return (
        <Flex vertical className="mt-05">
            <Button className="mb-1" variant="outlined" onClick={() => generateExcel(stakes)}>
                <FontAwesomeIcon icon={faFileExcel} />
                {t('actions.export.excel')}
            </Button>
            <Button onClick={() => generateImage()}>
                <FontAwesomeIcon icon={faFileImage} />
                {t('actions.export.image')}
            </Button>
        </Flex>
    );
};
